export const getBackwardsUrl = (): string => {
  const currentUrl = window.location.pathname + window.location.search;
  return currentUrl;
};
